/** Procsystim turquoise design tokens */
export const CF = {
  bgDeep: "#060B14",
  bgMid: "#0A1220",
  bgPanel: "#0F1A2E",
  bgCard: "#132238",
  primary: "#2DD4BF",
  primaryBright: "#5EEAD4",
  primaryDark: "#0D9488",
  cyan: "#22D3EE",
  cyanGlow: "rgba(34, 211, 238, 0.45)",
  tealGlow: "rgba(45, 212, 191, 0.4)",
  ringTrack: "rgba(45, 212, 191, 0.12)",
  ringActive: "#2DD4BF",
  text: "#F0FDFA",
  textSoft: "#CCFBF1",
  textMuted: "#64748B",
  textDim: "#475569",
  border: "rgba(45, 212, 191, 0.22)",
  borderStrong: "rgba(94, 234, 212, 0.55)",
  fail: "#FB7185",
  failGlow: "rgba(251, 113, 133, 0.35)",
  purpleAccent: "#A78BFA",
  white: "#FFFFFF",
};
